import { Contact } from '@trukt/types/Contact';

import { Typography } from '../../Typography';
import { OptionFormatterProps } from '../../inputs/selectOptions/SelectOption';

import { useStyles } from './ContactOptionFormatter.styles';

export const ContactOptionFormatter = ({
  option,
  variant,
}: OptionFormatterProps<
  string,
  Pick<Contact, 'name' | 'phoneNumber' | 'mobileNumber' | 'email'>
>) => {
  const styles = useStyles(variant);
  const data = option;

  if (!data.raw) return null;

  return (
    <div css={styles.root}>
      <div>
        <Typography css={styles.label}>{data.raw.name}</Typography>
        <div css={styles.iconContainer}>
          <Typography css={styles.label}>{data.raw.phoneNumber}</Typography>
        </div>
        <div css={styles.iconContainer}>
          <Typography css={styles.label}>{data.raw.mobileNumber}</Typography>
        </div>
        <div css={styles.iconContainer}>
          <Typography css={styles.label}>{data.raw.email}</Typography>
        </div>
      </div>
    </div>
  );
};
